var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wf-scroll"},[(!_vm.workFlowFlag)?_c('header',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.workflowName))])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }